module.exports = __webpack_public_path__ + "static/img/qiehuan1.d8544bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner/qiehuan1.jpg
// module id = wKSW
// module chunks = 44